export class SFPData {
    userId: string;
    mac?: string;
    locationComment?: string;
    account?: string;
    workorder?: string;
    location?: any;
    timestamp: number;
    uploadTimestamp: number;
    latitude: number;
    longitude: number;
    locationData?: any;
    txPower: number;
    txBias: number;
    rxPower: number;
    temperature: number;
    wavelength: number;
    vcc: number;
    tunable: {
        frequencies: {
            first: number;
            last: number;
        },
        tuned: {
            itu: number;
            wavelength: number;
        },
        itus: {
            first: number;
            last: number;
        },
        spacing: number;
    };
    module: {
        type: string;
        code: number;
    };
    vendorName: string;
    vendorDate: number;
    vendorPartNumber: string;
    vendorSerialNumber: string;
    vendorRev: string;
    oltSfp: {
        releaseType: string;
        linkCount: number;
        version: string;
        ethMac: string;
      }
      
}
